var React = require('react');

function ExternalArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.0001 9H21.7072V8.29289L21.0001 8.29289L21.0001 9ZM13 8.29289L12.2929 8.29289L12.2929 9.70711L13 9.70711L13 8.29289ZM20.293 17V17.7072H21.7072V17H20.293ZM20.5001 8.5L8.5 20.5001L9.5 21.5001L21.5001 9.5L20.5001 8.5ZM21.0001 8.29289L13 8.29289L13 9.70711L21.0001 9.70711L21.0001 8.29289ZM21.7072 17V9H20.293V17H21.7072Z","fill":"#212123"}));
}

ExternalArrow.defaultProps = {"id":"externalArrow","width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = ExternalArrow;

ExternalArrow.default = ExternalArrow;
